<template>
    <div>
        <h2 class="text-uppercase my-4">{{ t('clientsDeletion-clients_by_branch-title') }}</h2>

        <div class="row stats">
            <div class="col-12 ">
                <div class="row w-100">
                    <div v-for="(stat, idx) in stats.data" :key="idx" v-if="stat.branchName != 'Leads'" class="col-sm-12 col-md-4 mb-2">
                        <div  class="box">
                            <div class="icon">
                                <Icon icon-class="ui-building-01" size="13" />
                            </div>
                            <div class="info">
                                <div class="label">
                                    <strong>{{ t('clientsDeletion-clients_by_branch-clients_in', [stat.branchName]) }}</strong>
                                </div>

                                <div class="number">
                                    {{ stat.total }}
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "../components/icon/icon";

export default {
    components: {
        Icon
    },
    props: {
        stats: {
            type: Object,
            required: true
        }
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
}
</script>
